<lib-page
  [page]="surveyRenderStore.currentPageState().page!"
  class="block w-full rounded-2xl py-4 md:p-10 transition-all"
  [isValid]="surveyBotController.isValid()"
  (pageAction)="onPageAction($event)"
>
  <div class="global-plugin-layer">
    @for (plugin of activeGlobalPlugins(); track plugin.usageId) {
    <lib-plugin-host #globalPluginRef [pluginDef]="plugin"></lib-plugin-host>
    }
  </div>
</lib-page>
